export default 'h:mm:ss a';